module.exports = __webpack_public_path__ + "img/the usual offering box.f7532d96.png";